import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import { Injectable, inject } from '@angular/core';
import {AppState} from '../store';
import {select, Store} from '@ngrx/store';
import {selectLatestLessonsState} from '../store/latest-lessons.selectors';
import {filter, first, tap} from 'rxjs/operators';
import {loadNextLatestLessonsPage} from '../store/latest-lesson.actions';


@Injectable({
  providedIn: 'root'
})
export class LatestLessonsResolver  {
  private store = inject<Store<AppState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {

  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.store
      .pipe(
        select(selectLatestLessonsState),
        tap(state => {
          if (state.lastPageLoaded == null) {
            this.store.dispatch(loadNextLatestLessonsPage());
          }
        }),
        filter(state => state.lastPageLoaded >= 0),
        first()
      );
  }

}
